<template>
  <div>
    <div id="cesiumContainer"></div>
    <!-- <sm-viewer :scene-url="URL" > -->
    <!-- </sm-viewer> -->
    <div>
      <!-- {{ tableData }} -->
    </div>
  </div>
</template>

<script>
import { deviceArr} from '@/assets/js/device'
export default {
  name: 'DeqingBridgeAndTunnelXunchajihua',

  props: ['tableData'],
  data() {
    return {
      URL:'https://supermap.51wephone.cn/iserver/services/3D-wc/rest/realspace',
      viewer:null
    }
  },
  watch:{
    tableData:{
      handler(newdata, olddata) {
        console.log('newdata', newdata)
        if (newdata) {
          let tempArr = deviceArr.filter(item=>newdata.some(val=>val.equipmentName===item.bridgeName))
          this.addPoint(tempArr)
        }
      }
    }
  },
  
  mounted() {
    let that = this
    setTimeout(()=>{
      let tempArr = deviceArr.filter(item=>that.tableData.some(val=>val.equipmentName===item.bridgeName))
      that.viewer = new Cesium.Viewer('cesiumContainer');
      that.viewer.imageryLayers.addImageryProvider(new Cesium.BingMapsImageryProvider({
              url : 'https://dev.virtualearth.net',
              mapStyle : Cesium.BingMapsStyle.AERIAL,
              key : 'AgYCj_VzN0MWJ-4pgJj3I7bZym9kmbb-HDWjG5cgHFJxNOokbRcSEtUwJM3uWweh'
          }));
      that.viewer.scene.open("https://supermap.51wephone.cn/iserver/services/3D-wc/rest/realspace");
      that.addPoint(tempArr)
    },300)
  },

  methods:{
    addPoint(tempArr){
      let that = this
      that.viewer.entities.removeAll();
      tempArr.map(item=>{
        that.viewer.entities.add({
            id:item.bridgeName,
            position: Cesium.Cartesian3.fromDegrees(parseFloat(item.longitude), parseFloat(item.latitude), parseFloat(item.height)),
            billboard:{
              image: item.image,
              width:15,
              height:17,
            },
            // point:new Cesium.PointGraphics ( {
            //     show : true,
            //     pixelSize :  5,
            //     heightReference : Cesium.HeightReference.NONE,
            //     color : new Cesium.Color.fromCssColorString(item.color),
            //     outlineColor : new Cesium.Color ( 0 , 0 , 0 , 0 ),
            //     outlineWidth : 0,
            //     scaleByDistance : new Cesium.NearFarScalar ( 0 , 1 , 5e10 , 1 ),
            //     translucencyByDistance : new Cesium.NearFarScalar ( 0 , 1 , 5e10 , 1 ),
            //     distanceDisplayCondition : new Cesium.DistanceDisplayCondition(0, 4.8e10),
            // } ),
            name: item.bridgeName,
            description: item.bridgeName
        });
      })
      // if(tempArr.some(item=>item.bridgeName.indexOf('GNSS')==-1)){
        // that.viewer.zoomTo(that.viewer.entities)
      // }
      // var handler = new Cesium.ScreenSpaceEventHandler(that.viewer.scene.canvas);
      //     handler.setInputAction(function(movement) {
      //       var pick = that.viewer.scene.pick(movement.position);
      //       if(Cesium.defined(pick) ) {
      //         if(pick.id.id&&pick.id.id.indexOf('00')==-1){
      //           that.$emit('pickDevice', pick.id.id)
      //         }
      //       }
      //     },Cesium.ScreenSpaceEventType.LEFT_CLICK);
  
      //     // 鼠标移入labelEntity提示框
      //     handler.setInputAction(function(movement) {
  
      //       // var foundPosition = false;
  
      //       if (that.viewer.scene.mode !== Cesium.SceneMode.MORPHING) {
      //         var pickedObject = that.viewer.scene.pick(movement.endPosition);
      //         if(Cesium.defined(pickedObject)) {
      //           if(pickedObject.id.id &&pickedObject.id.id.indexOf('00')==-1){
      //             that.$emit('pickDevice', pickedObject.id.id)
      //           }
      //         }
      //       }
  
      //       // if (!foundPosition) {
      //       //   labelEntity.label.show = false;
      //       // }
      //     }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
    }
  }
}
</script>

<style lang="scss" scoped>
.modul-search {
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.caozuotianbiao {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.caozuotianbiao-from {
  width: 70%;
  min-height: 750px;
  background-color: #fff;
  text-align: left;
  padding: 20px;
  position: relative;
  padding-top: 60px;
  padding-left: 120px;

  .modul-top {
    position: absolute;
    left: 15px;
    top: 0;
  }
}
/deep/ .cesium-viewer-navigationContainer{
  top:400px !important;
  right: 500px !important;
}
</style>
